import { hasEnabledFeature } from 'globalutils/fmUtils';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const isCAEnabled = hasEnabledFeature('canadaComplianceEnabled');

const leftMenu = [
  {
    icon: mediaUrls.logs,
    label: 'leftMenu.logs',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER'],
    path: '/logs/list',
    module: 'wLogs',
  },
  {
    icon: mediaUrls.user,
    label: 'leftMenu.users',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/user/list',
    module: 'wUsersList',
  },
  {
    icon: mediaUrls.vehicle,
    label: 'leftMenu.vehicles',
    roles: ['FLMANAGER', 'ADMIN', 'MECHANIC'],
    path: '/vehicle/list',
    module: 'wVehiclesList',
  },
  {
    icon: mediaUrls.accident,
    label: 'leftMenu.accidents',
    roles: ['FLMANAGER', 'ADMIN', 'MECHANIC'],
    path: '/accidents/list',
    module: 'wAccidents',
  },
  {
    icon: mediaUrls.repair,
    label: 'leftMenu.repairMaintenance',
    roles: ['FLMANAGER', 'ADMIN', 'MECHANIC'],
    path: '/workorders/list',
    module: 'wReportAndMaintenance',
  },
  {
    icon: mediaUrls.inspections,
    label: 'leftMenu.inspections',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/inspections/list',
  },
  {
    icon: mediaUrls.csa,
    label: 'leftMenu.csaViolation',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/csa/violation',
    module: 'csaViolationFieldWaitingEnabled',
  },
  {
    icon: mediaUrls.filter,
    label: 'leftMenu.filters',
    roles: ['FLMANAGER'],
    isFilter: true,
  },
  {
    icon: mediaUrls.company,
    label: 'leftMenu.companyData',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/company/edit',
  },
  {
    icon: mediaUrls.usdot,
    label: 'leftMenu.USDOT',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'usDotManagementenabled',
    path: '/usdot/management',
  },
  {
    icon: mediaUrls.dotAuditIcon,
    label: isCAEnabled ? 'leftMenu.Audit' : 'leftMenu.DOTAudit',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/logs/fmcsaLogs',
  },
  {
    icon: mediaUrls.policy,
    label: 'leftMenu.policiesProcedures',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/policy/edit',
  },
  {
    icon: mediaUrls.document,
    label: 'leftMenu.documents',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/company/document/edit',
  },
  {
    icon: mediaUrls.dailyDocuments,
    label: 'leftMenu.dailyDocuments',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/dailyDocuments/list',
  },
  {
    icon: mediaUrls.departments,
    label: 'common.departments',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/department/list/default',
  },
  {
    icon: mediaUrls.fuel,
    label: 'leftMenu.fuelReport',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/fuel/list',
  },
  {
    icon: mediaUrls.ifta,
    label: 'leftMenu.IFTAReport',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/report/mileage',
  },
  {
    icon: mediaUrls.reports,
    label: 'leftMenu.reports',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/report',
  },
  {
    icon: mediaUrls.downloadCenterMenu,
    label: 'leftMenu.downloadCenter',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/downloadCenter/list',
  },
  {
    icon: mediaUrls.developer,
    label: 'leftMenu.developerRequests',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/alerts/requests',
  },
  {
    icon: mediaUrls.feedback,
    label: 'leftMenu.feedback',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER', 'MECHANIC'],
    path: '/feedback',
  },
];
export default leftMenu;
// export default (leftMenu);
